import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { ONBOARDING_URL } from '../../utils/redirect-const'

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 0),
  backgroundColor: '#fff',
  textAlign: 'left',
}));

const StyledButton = styled(Button)({
  backgroundColor: '#fda4af',
  height: '44px',
  color: 'white',
  '&:hover': {
    backgroundColor: '#fb7185',
  },
  boxShadow: 'none !important',
});

const Image = styled('img')({
  width: '100%',
  height: 'auto',
  borderRadius: '8px',
});

const ButtonWrapper = styled('div')({
  marginTop: '8px',
  textAlign: 'center',
});

const Hero = () => {
  return (
    <Root>
      <Container>
        <Grid container spacing={1} alignItems="center" textAlign="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h2" gutterBottom>
              Rozszerzanie diety dziecka
            </Typography>
            <Typography variant="body2">
              Twoje wsparcie w rozszerzaniu diety dziecka.
            </Typography>
            <Typography variant="body2">
              Encyklopedia produktów, przepisy i inne.
            </Typography>
            <ButtonWrapper>
              <Link to={ONBOARDING_URL} style={{ textDecoration: 'none' }}>
                <StyledButton variant="contained">
                  Zaczynam
                </StyledButton>
              </Link>
            </ButtonWrapper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Image src="https://res.cloudinary.com/subframe/image/upload/v1718725845/uploads/3388/e52yritjpw3pl8mor0nm.jpg" alt="Baby eating" />
          </Grid>
        </Grid>
      </Container>
    </Root>
  );
};

export default Hero;